import { Delete } from "lucide-react";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
// Immediate "the touch registered" feedback on every key — flips to solid blue / white text
// while the finger/mouse is down (native :active), then snaps back the instant it's released.
const keyBase = "h-16 rounded-xl border border-zinc-200 shadow-sm font-bold select-none transition-all duration-150 active:scale-95 active:bg-blue-600 active:text-white active:border-blue-600";
const keyFont = { fontFamily: "Poppins, sans-serif" };

export function LoginNumpad({ onDigit, onBackspace, onClear, disabled = false }) {
  return (
    <div className="grid grid-cols-3 gap-2" data-testid="login-numpad">
      {KEYS.map((k) => (
        <button key={k} type="button" disabled={disabled} onClick={() => onDigit(k)} style={keyFont}
          className={`${keyBase} bg-white hover:bg-zinc-50 text-3xl text-zinc-800`} data-testid={`login-numpad-key-${k}`}>
          {k}
        </button>
      ))}
      <button type="button" disabled={disabled} onClick={onClear} style={keyFont}
        className={`${keyBase} bg-red-50 hover:bg-red-100 border-red-200 text-lg text-red-600`} data-testid="login-numpad-clear">
        CLEAR
      </button>
      <button type="button" disabled={disabled} onClick={() => onDigit("0")} style={keyFont}
        className={`${keyBase} bg-white hover:bg-zinc-50 text-3xl text-zinc-800`} data-testid="login-numpad-key-0">
        0
      </button>
      <button type="button" disabled={disabled} onClick={onBackspace} aria-label="Backspace"
        className={`${keyBase} bg-zinc-100 hover:bg-zinc-200 text-zinc-700 flex items-center justify-center`} data-testid="login-numpad-backspace">
        <Delete className="w-7 h-7" />
      </button>
      <button type="submit" disabled={disabled} style={keyFont}
        className={`${keyBase} col-span-3 bg-green-600 hover:bg-green-700 border-green-700 text-white text-xl tracking-widest shadow-lg`} data-testid="login-numpad-enter">
        {disabled ? "SIGNING IN..." : "ENTER"}
      </button>
    </div>
  );
}
